import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiFlowLabelComponent } from '../../atoms/flow-label/flow-label.component';
import { UiFlowNodeFrameComponent } from '../../atoms/flow-node-frame/flow-node-frame.component';

@Component({
  selector: 'ui-flow-process-node',
  standalone: true,
  imports: [UiFlowNodeFrameComponent, UiFlowLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui-flow-node">
      <ui-flow-node-frame shape="rect">
        <ui-flow-label [text]="label()" tone="strong" />
      </ui-flow-node-frame>
      @if (caption()) {
        <ui-flow-label [text]="caption()!" tone="muted" />
      }
    </div>
  `,
  styles: `
    :host { display: inline-flex; }
    /* Ancho fijo: debe coincidir con NODE_SIZES.process en flow-layout.util.ts */
    .ui-flow-node {
      display: inline-flex;
      width: 160px;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }
    ui-flow-node-frame { width: 100%; }
  `,
})
export class UiFlowProcessNodeComponent {
  readonly label = input.required<string>();
  readonly caption = input<string | null>(null);
}
